$(document).ready(function() {
  check_all_checkboxes();
});

function check_all_checkboxes(){
  $('.close_message').click(function() {
     $('.message').addClass('hidden');
  });
}
